(function () {
  const root = document.querySelector('[data-nav-root]');
  if (!root) return;

  const mqDesktop = window.matchMedia(
    `(min-width: ${getComputedStyle(document.documentElement).getPropertyValue('--nav-breakpoint').trim()})`
  );

  // chiudi tutto
  function closeAll() {
    root.querySelectorAll('.nav__item.is-open').forEach(li => {
      li.classList.remove('is-open');
      const btn = li.querySelector('.nav__toggle');
      const link = li.querySelector('.nav__link');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  }

  // click-outside
  document.addEventListener('click', (e) => {
    if (!root.contains(e.target)) closeAll();
  });

  // Esc chiude
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeAll(); root.querySelector('[data-nav-root-link]')?.focus(); }
  });

  // toggle con bottone (mobile e fallback desktop)
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('.nav__toggle');
    if (!btn) return;
    const li = btn.closest('.nav__item');
    const open = li.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(open));
    const link = li.querySelector('.nav__link');
    if (link) link.setAttribute('aria-expanded', String(open));
    // chiudi fratelli
    li.parentElement.querySelectorAll(':scope > .nav__item.is-open').forEach(sib => {
      if (sib !== li) {
        sib.classList.remove('is-open');
        sib.querySelector('.nav__toggle')?.setAttribute('aria-expanded','false');
        sib.querySelector('.nav__link')?.setAttribute('aria-expanded','false');
      }
    });
  });

  // chiudi quando esci da un item di 1° livello
  root.querySelectorAll('.depth-1 > .nav__item.has-children').forEach(li => {
    li.addEventListener('mouseleave', () => {
      li.classList.remove('is-open');
      li.querySelector('.nav__toggle')?.setAttribute('aria-expanded','false');
      li.querySelector('.nav__link')?.setAttribute('aria-expanded','false');
    });
  });

  // desktop: open on focus/hover
  if (mqDesktop.matches) {
    root.querySelectorAll('.depth-1 > .nav__item.has-children > .nav__link').forEach(a => {
      a.addEventListener('focus', () => a.closest('.nav__item').classList.add('is-open'));
      a.addEventListener('blur', () => a.closest('.nav__item').classList.remove('is-open'));
    });
  }

  // chiudi quando il mouse esce dal nav (desktop)
  root.addEventListener('mouseleave', () => {
    if (mqDesktop.matches) closeAll();
  });

  // chiudi quando il focus esce dal nav (a11y)
  root.addEventListener('focusout', (e) => {
    if (!root.contains(e.relatedTarget)) closeAll();
  });

  // prevenzione overflow per i flyout di 3° livello
  root.querySelectorAll('.depth-2 > .nav__item.has-children').forEach(li => {
    li.addEventListener('mouseenter', () => {
      const fly = li.querySelector(':scope > .depth-3');
      if (!fly) return;
      const r = fly.getBoundingClientRect();
      if (r.right > window.innerWidth) fly.classList.add('align-left');
      else fly.classList.remove('align-left');
    });
  });
})();
